var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.has_lineage
    ? _c("div", { staticClass: "text-center" }, [
        _vm._v("No hay linaje para este objeto"),
      ])
    : _c("div", {
        staticStyle: { "background-color": "#FFFFF !important" },
        attrs: { id: "container" },
      })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }